export class MicrosoftEntityDisconnectedRequest{
    public customerId!:number;
    public clientId!:number;
}
